import register from 'ShopUiBundle/modules/app/registry';
import 'SprykerCatalogBundle/components/molecules/catalog-search-box';
import './header-search-form.scss';

// tslint:disable-next-line
register('header-search-form', () => import(/* webpackMode: "lazy" */'./header-search-form'));
